import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { ConfirmDialogHost } from "./lib/confirmDialog";
import { preventIosFocusZoom } from "./lib/iosFocusZoom";
import { initInstallEventCapture } from "./pwa/installEvent";
import "./styles.css";

// iPhone: sin esto, tocar un campo de menos de 16px amplía la página y el
// header y el nav de torneo/categoría fijos se salen al bajar (ver el módulo).
preventIosFocusZoom();

const THEME_STORAGE_KEY = "cymergold_tenis_theme";
const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
document.documentElement.dataset.theme = storedTheme === "light" ? "light" : "dark";
document.documentElement.style.colorScheme = storedTheme === "light" ? "light" : "dark";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const configuredBasename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";
const isTorneos123Host = window.location.hostname.endsWith("torneos123.com");
const isTenisMountedPath = window.location.pathname === "/tenis" || window.location.pathname.startsWith("/tenis/");
const basename = isTorneos123Host ? "/" : isTenisMountedPath ? "/tenis" : configuredBasename;

initInstallEventCapture();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <AuthProvider>
          <App />
          {/* Único anfitrión de confirmaciones dentro de la página (sustituye a window.confirm). */}
          <ConfirmDialogHost />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
